import Vue from 'vue';
const resource = '/orderitems';

export default {
  // CUSTOM ENDPOINT
  getByOrder(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`orders/${idPublic}${resource}`);
  },
  getByItem(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`items/${idPublic}${resource}`);
  },
  getByOrderWithWorkOrderItemOrderItems(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `orders/${idPublic}${resource}?include=workorderitemorderitems`
    );
  },
  getWithWorkOrderItemOrderItems(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `${resource}/${idPublic}?include=workorderitemorderitems`
    );
  },
};
